import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js';
import { OrbitControls } from 'https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/loaders/GLTFLoader.js';

const elements = document.querySelectorAll('[data-lp-3d]');

elements.forEach((el, index) => {
  const modelUrl = el.dataset.modelUrl;

  if (!modelUrl || modelUrl.includes('ここに別のglb')) {
    console.warn(`LP 3D ${index + 1}: model URL is empty`);
    return;
  }

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(
    45,
    el.clientWidth / el.clientHeight,
    0.1,
    1000
  );

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(el.clientWidth, el.clientHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setClearColor(0x000000, 0);
  el.appendChild(renderer.domElement);

  scene.add(new THREE.AmbientLight(0xffffff, 2));

  const light = new THREE.DirectionalLight(0xffffff, 3);
  light.position.set(5, 5, 5);
  scene.add(light);

  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.enableZoom = false;
  controls.enablePan = false;

  let model = null;

  const loader = new GLTFLoader();

  loader.load(
    modelUrl,
    (gltf) => {
      model = gltf.scene;

      const box = new THREE.Box3().setFromObject(model);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());

      model.position.sub(center);

      const maxDim = Math.max(size.x, size.y, size.z);
      model.scale.setScalar(3.5 / maxDim);

      scene.add(model);

      camera.position.set(0, 1.2, 4);
      camera.lookAt(0, 0, 0);
    },
    undefined,
    (error) => {
      console.error(`LP 3D ${index + 1}: GLB load error`, error);
    }
  );

  function animate() {
    requestAnimationFrame(animate);

    if (model) {
      const rect = el.getBoundingClientRect();
      const progress = 1 - rect.top / window.innerHeight;
      model.rotation.y = progress * 1.2;
    }

    controls.update();
    renderer.render(scene, camera);
  }

  animate();

  window.addEventListener('resize', () => {
    camera.aspect = el.clientWidth / el.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(el.clientWidth, el.clientHeight);
  });
});